<template>
  <a-card class="voice-item-1">
    <voice-header :data="data||{}">
      <template slot="btn">
        <a-button v-has="'checkdata:batchCloseQuestion'" style="margin-left: 20px" v-if="questionList.length>0" @click="closeQuestionListHandle">
          批量关闭质疑
        </a-button>
      </template>
    </voice-header>
    <div style="min-height: 300px">
      <div class="row">
        查看内容：
        <a-radio-group v-model="queryParams.error" >
          <a-radio-button value="0">
            全部
          </a-radio-button>
          <a-radio-button value="1">
            失败
          </a-radio-button>
        </a-radio-group>

        <a-button style="margin-left: 20px" type="primary" @click="closeSubmit">
          核查完成
        </a-button>
      </div>
      <template v-for="(item,index) in vformItemList">
        <div v-show="queryParams.error == '0' || (queryParams.error == '1' && '1' != item.status)">
          <a-divider />
          <a-row class="form-item-row" :key="index" :gutter="20">
            <a-col :span="getSpanL(item)" :class="'1'!=item.status?'error-col':''">
              <div>
                <a-button type="link" :icon="item.view?'up':'down'" @click="item.view=!item.view"></a-button>
                {{item.patientFormItem.number || ''}}{{item.patientFormItem.name}}
                <a-tag v-if="errorData[item.status]" :color="errorData[item.status].color" >{{ errorData[item.status].text }}</a-tag>
                <div style="float: right;">
                  <a-button :icon="item.view?'right':'left'" size="small" @click="item.view=!item.view">{{item.view?'收起':'展开'}}</a-button>
                </div>
              </div>
              <div>
                <form-view-item :isCom="true" :baseData="data.form" :readOnly="true" :questionList="questionList" :show-tip-btn="true" :form-item="item.patientFormItem" :form.sync="formBaseData" ></form-view-item>
              </div>
              <div v-show="item.view">
                语音核查答案：
              </div>
              <div v-show="item.view">
                <form-view-item-input :readOnly="true" style="width: 100%" :form.sync="formVoiceData" :form-item="item" ></form-view-item-input>
              </div>
            </a-col>
            <a-col :span="getSpanR(item)">
              <a-row :gutter="20">
                <a-col :span="12">
                  <div v-if="item.voiceNlpList && item.voiceNlpList.length>0">
                    <a-button :type="item.currentModelCode == nlpItem.modelCode?'primary':'default'" size="small" v-for="(nlpItem,nlpIndex) in (item.voiceNlpList)" :key="nlpIndex" @click="item.currentModelCode = nlpItem.modelCode">{{modelData[nlpItem.modelCode]}}</a-button>
                    <div class="voice-panel" :class="'1'!=item.status?'error':''">
                      <div>
                        语音值：{{item.voiceValue || '无'}}
                      </div>
                      {{getNlpInfo(item).result}}
                    </div>
                  </div>
                  <div v-else class="error">
                    数据异常：无语音模型信息
                  </div>
                </a-col>
                <a-col :span="12">
                  <div >
                    <div>
                      <a-button :type="item.currentPlay == '1'?'primary':'default'" size="small" @click="item.currentPlay = '1'">原始语音</a-button>
                      <a-button :type="item.currentPlay == '2'?'primary':'default'" size="small" @click="item.currentPlay = '2'">降噪语音</a-button>
                    </div>
                    <div style="margin-top: 10px">
                      <play v-if="item.currentPlay == '1'" :localPath="true" :data="playData(item.url,'原始语音')"></play>
                      <play v-if="item.currentPlay == '2'" :localPath="true" :data="playData(item.noiseUrl,'降噪后语音')"></play>
                    </div>
                  </div>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
        </div>

      </template>
    </div>
    <a-modal
      title="批量关闭质疑"
      width="80%"
      :visible="closeQuestionListVisible"
      :confirmLoading="loading"
      @ok="handleCloseQuestionListSubmit"
      @cancel="handleCloseQuestionListCancel">
      <a-row style="margin-bottom: 20px">
        <a-col :span="4" style="text-align: right">关闭理由：</a-col>
        <a-col :span="18">
          <div style="margin-bottom: 10px">
            <a-radio-group buttonStyle="solid" v-model="questionForm.handleInfo">
              <a-radio value="已修改">已修改</a-radio>
              <a-radio value="无需修改">无需修改</a-radio>
              <a-radio value="-1">其他</a-radio>
            </a-radio-group>
          </div>
          <div v-if="questionForm.handleInfo==='-1'">
            <a-textarea :rows="2"  placeholder="请输入" v-model="questionForm.description" />
          </div>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="4" style="text-align: right">质疑元素：</a-col>
        <a-col :span="18">
          <a-table
            size="small"
            bordered
            rowKey="id"
            :columns="questionColumns"
            :dataSource="questionList"
            :pagination="false"
            :rowSelection="{selectedRowKeys:questionSelectedRowKeys, onChange: onQuestionSelectChange, type: 'checkbox'}"
            :loading="loading"
          >
          </a-table>
        </a-col>
      </a-row>
    </a-modal>
  </a-card>
</template>

<script>

  import VoiceHeader from './components/VoiceHeader'
  import { getAction ,postAction} from '@/api/manage'
  import FormViewItem from '@/views/project/components/FormViewItem'
  import {elementTypeData ,CACHE_PROJECT_ID} from '@/constants/project'
  import FormViewItemInput from '@/views/project/components/FormViewItemInput'
  import Vue from 'vue'
  import Play from '@/views/project/patient/components/recording/Play'
  export default {
    name: 'VoiceItem1',
    components: { FormViewItemInput, FormViewItem,  VoiceHeader,Play },
    props:{
      data:{
        type:Object,
        default:()=>{
          return {}
        }
      }
    },
    inject:['closeCurrent'],
    data(){
      return {
        projectId:Vue.ls.get(CACHE_PROJECT_ID) ||'',
        queryParams:{
          error:'1',
        },
        vformItemList:[],
        formBaseData:{},
        formVoiceData:{},
        questionList:[],
        loading:false,
        closeQuestionListVisible:false,
        questionForm:{
          handleInfo:'',
          description:''
        },
        questionSelectedRowKeys:[],
        errorData:{
          '1':{
            text:'正确',
            color:'green'
          },
          '2':{
            text:'答案不一致',
            color:'#f50'
          },
          '3':{
            text:'识别失败',
            color:'#FF0000'
          }
        },
        questionColumns:[
          {
            title: '元素名称',
            align: "center",
            dataIndex: 'formItemName',
            width: 200
          },
          {
            title: '相关质疑',
            align: "center",
            dataIndex: 'description',
            width: 200
          },
        ],
        modelData:{}
      }
    },
    computed:{
    },
    watch:{
      data(){
        this.init()
      }
    },
    mounted(){
      getAction('/project/voiceConfig/listAll',{projectId:this.projectId}).then(res=>{
        if(res.success){
          const modelData = {}
          res.result.forEach(item=>{
            modelData[item.code] = item.name
          })
          this.modelData = modelData
        }
      })
      this.init()
    },
    provide(){
      return{
        parentLoadData:this.init,
      }
    },
    methods:{
      init(){
        if(!this.data.id){
          return
        }
        getAction('/voice/voiceApplyFormItem/queryByFormId',{patientFormId:this.data.paFormId,voiceBatchId:this.data.voiceBatchId}).then(res=>{
          if(res.success){
            const formItemList = []
            res.result.forEach(item=>{
              if(!item.currentModelCode && item.voiceNlpList && item.voiceNlpList.length>0){
                item.currentModelCode = item.voiceNlpList[0].modelCode
              }
              item.id = item.paFormItemId
              item.formItemId = item.paFormItemId
              item.element = item.patientFormItem.element
              item.currentPlay = '1'
              if(item.status=='1'){
                item.view = false
              }
              else{
                item.view = true
              }
              formItemList.push(item.patientFormItem)
            })

            this.vformItemList =res.result
            const form = {}
            this.initFrom(formItemList,form)
            this.formBaseData = form;

            const vform = {}
            this.initFrom(this.vformItemList,vform,'voiceValue')
            this.formVoiceData = vform;
          }
        })

        this.loadQuestionList()
      },
      closeSubmit(){
        console.log(11,this.data.paFormId)
        postAction('/voice/voiceApplyForm/checkPaFormStatus',{ids:this.data.id}).then(res=>{
              if(res.success){
                if(res.result.length>0){
                  this.$message.warning('当前表单存在尚未处理的质疑，请先处理质疑再进行核查操作!')
                  return
                }
              }
            })
        this.$confirm({
          title: '提示',
          content: '确认核查完成吗?',
          onOk:()=> {
            postAction('/voice/voiceApplyForm/checkSubmit',{ids:this.data.id}).then(res=>{
              if(res.success){
                this.closeCurrent()
              }
            })
          },
          onCancel() {
          },
        })
      },
      loadQuestionList(){
        this.loading = true
        //获取当前表单的质疑记录
        getAction('/question/patientQuestion/listAll',{projectId:this.projectId,status:'1',supper:JSON.stringify({paFormIdList:[this.data.paFormId]})}).then(res=>{
          if(res.success){
            this.questionList = res.result
          }
        }).finally(()=>{
          this.loading = false
        })
      },
      closeQuestionListHandle(e){
        // 阻止事件冒泡
        e.stopPropagation()
        this.closeQuestionListVisible = true
      },
      handleCloseQuestionListSubmit(){
        if(this.questionSelectedRowKeys.length===0){
          return this.$message.warning('请选择质疑元素')
        }
        if(!this.questionForm.handleInfo){
          return this.$message.warning('请选择关闭理由')
        }
        const params = {
          idList:this.questionSelectedRowKeys,
          projectId:this.projectId
        }
        if(this.questionForm.handleInfo==='-1'){
          if(!this.questionForm.description){
            return this.$message.warning('请输入“其他”关闭理由')
          }else{
            params.description = this.questionForm.description
          }
        }else{
          params.description = this.questionForm.handleInfo
        }
        postAction('/question/patientQuestion/closeList',params).then(res=>{
          if(res.success){
            this.$message.success(res.message)
            this.loadQuestionList();
            this.handleCloseQuestionListCancel()
          }
        })
      },
      handleCloseQuestionListCancel(){
        this.closeQuestionListVisible = false
      },
      onQuestionSelectChange(selectedRowKeys, selectedRows) {
        this.questionSelectedRowKeys = selectedRowKeys;
      },
      getNlpInfo(formItem){
        let result = {}
        const voiceNlpList = formItem.voiceNlpList || []
        voiceNlpList.forEach(item=>{
          if(item.modelCode == formItem.currentModelCode){
            result = item
          }
        })
        return result
      },
      playData(url,title){
        return {
          title:title,
          path:url
        }
      },
      initFrom(formItemList,form,valueKey){
        valueKey = valueKey || 'value'
        if(formItemList && formItemList.length>0){
          formItemList.forEach(item=>{
            let value = item[valueKey]
            if(value){
              if(item.element && item.element.type ===elementTypeData.number.value ){
                try {
                  if(item.element.reDecimal==='1'){
                    value = parseFloat(value)
                  }else{
                    value = parseInt(value)
                  }
                }catch (e) {
                  value=null;
                }
              }
              else if(item.element&& item.element.type ===elementTypeData.check.value ){
                value = value.split(',')
              }
              else if(item.element && elementTypeData.slider.value === item.element.type ){
                try {
                  value = parseInt(value)
                }catch (e) {
                  value=null;
                }
              }
              form[item.id] = value
            }else if(item.element && item.element.type ===elementTypeData.check.value){
              form[item.id] = []
            }
            else if(item.element && item.element.type ===elementTypeData.slider.value){
              form[item.id] = 0
            }
            else{
              form[item.id] = ''
            }
          })
        }
      },
      getSpanL(vformItem){
        if(vformItem.view){
          return 14
        }
        return 24
      },
      getSpanR(vformItem){
        if(vformItem.view){
          return 10
        }
        return 0
      }
    }
  }
</script>

<style scoped lang="less">
  .voice-item-1{
    .row{
      margin: 10px ;
    }
    .error{
      color: red;
    }
    .form-item-row{

    }
    .error-col{
      color: red;
    }
    .voice-panel{
      border: 1px solid rgba(0,0,0,0.3);
      padding: 5px;
      height: 110px;
      overflow-y: auto;
    }
  }
</style>